import { Box, Button, Drawer, Divider, Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Link } from "react-router-dom";
import axios from "axios";
import { useEffect, useState } from "react";
import { exitApp } from "assets/js/apphandle";
import { goLink } from "assets/js/common";
import { useHistory } from "react-router-dom";
import { loadLinkAlert } from "redux/reducers/top";
import { useDispatch, useSelector } from "react-redux";

export default function Market(props) {
  const { handleSidebarClose, open, handleAlertClose, goPage, sidebar } = props;
  const history = useHistory();
  const dispatch = useDispatch();
  const { linkAlert } = useSelector((state) => state.top);

  useEffect(() => {
    window.appBackKeyHandle = () => {
      if (open) {
        handleAlertClose();
      } else if (linkAlert) {
        dispatch(loadLinkAlert(""));
      } else if (sidebar) {
        handleSidebarClose();
      } else if (window.location.pathname != "/") {
        history.goBack();
      } else {
        exitApp();
      }
    };
  }, [open, sidebar, linkAlert]);

  useEffect(() => {
    window.appBackKeyHandle = () => {
      if (open) {
        handleAlertClose();
      } else if (linkAlert) {
        dispatch(loadLinkAlert(""));
      } else if (sidebar) {
        handleSidebarClose();
      } else if (window.location.pathname != "/") {
        history.goBack();
      } else {
        exitApp();
      }
    };
  });

  return (
    <>
      <Box className="box-type-1 category-box">
        <h4>행사안내</h4>
        <Grid container spacing={1}>
          <Grid item xs={3}>
            <Link to={"/product-of-week"} onClick={handleSidebarClose}>
              {/* <Link to={"/"} onClick={handleSidebarClose}> */}
              <div className="img-fixed">
                <img
                  src={`${process.env.PUBLIC_URL}/images/icon/left_flyer.svg`}
                />
              </div>
              <span className="nm">전단광고</span>
            </Link>
          </Grid>
          <Grid item xs={3}>
            <Link to={"/event"} onClick={handleSidebarClose}>
              <div className="img-fixed">
                <img
                  src={`${process.env.PUBLIC_URL}/images/icon/left_event.svg`}
                />
              </div>
              <span className="nm">이벤트</span>
            </Link>
          </Grid>
          {/* <Grid item xs={3}>
            <Link to={"/event"} onClick={handleSidebarClose}>
              <div className="img-fixed">
                <img
                  src={`${
                    process.env.PUBLIC_URL
                  }/images/icon/left_megaorder.svg`}
                />
              </div>
              <span className="nm">메가오더</span>
            </Link>
          </Grid> */}
          <Grid item xs={3}>
            <Button
              onClick={() => {
                dispatch(
                  loadLinkAlert("https://shoppinglive.naver.com/channels/78178")
                );
              }}
            >
              <div className="img-fixed">
                <img
                  src={`${process.env.PUBLIC_URL}/images/icon/left_live.svg`}
                />
              </div>
              <span className="nm">라이브</span>
            </Button>
          </Grid>
          <Grid item xs={3}>
            <Button
              onClick={() => {
                goPage("/shopping-memo");
              }}
            >
              <div className="img-fixed">
                <img
                  src={`${
                    process.env.PUBLIC_URL
                  }/images/icon/left_shoppingmemo.svg`}
                />
              </div>
              <span className="nm">쇼핑메모</span>
            </Button>
          </Grid>
          {/* <Grid item xs={3}>
            <Link to={"/"} onClick={handleSidebarClose}>
              <div className="img-fixed">
                <img
                  src={`${
                    process.env.PUBLIC_URL
                  }/images/icon/left_reservation.svg`}
                />
              </div>
              <span className="nm">사전예약</span>
            </Link>
          </Grid> */}
        </Grid>
      </Box>
      <Divider />

      <Box className="box-type-1 category-box">
        <h4>혜택</h4>
        <Grid container spacing={1}>
          <Grid item xs={3}>
            <Button
              onClick={() => {
                goPage("/coupon");
              }}
            >
              <div className="img-fixed">
                <img
                  src={`${process.env.PUBLIC_URL}/images/icon/left_coupon.svg`}
                />
              </div>
              <span className="nm">쿠폰</span>
            </Button>
          </Grid>
          <Grid item xs={3}>
            <Button
              onClick={() => {
                goPage("/stamp");
              }}
            >
              <div className="img-fixed">
                <img
                  src={`${process.env.PUBLIC_URL}/images/icon/left_stamp.svg`}
                />
              </div>
              <span className="nm">스탬프</span>
            </Button>
          </Grid>
          <Grid item xs={3}>
            <Button
              onClick={() => {
                goPage("/point");
              }}
            >
              <div className="img-fixed">
                <img
                  src={`${process.env.PUBLIC_URL}/images/icon/left_point.svg`}
                />
              </div>
              <span className="nm">포인트</span>
            </Button>
          </Grid>
          <Grid item xs={3}>
            <Button
              onClick={() => {
                goPage("/my-review");
              }}
            >
              <div className="img-fixed">
                <img
                  src={`${
                    process.env.PUBLIC_URL
                  }/images/icon/left_myreview.svg`}
                />
              </div>
              <span className="nm">M.리뷰</span>
            </Button>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
